<section class="area-login animate__animated animate__fadeIn" [ngStyle]="{ 'background-image': 'url(' + randomImage + ')' }">
  <mat-card class="login" style="position: relative;">

    <mat-card-content>

      <div class="simpli-floating-box-header">
        <div class="simpli-floating-box-logo text-center">
          <img src="../../assets/simpli/simplilogo2.svg" height="90px">
          @if (alianza === 'ingram') {
            <img src="https://simpliassets12daacw.s3.us-east-2.amazonaws.com/Ingram_micro_logo.png" style="width: 200px;margin: 0 auto;margin-bottom: 10px;">
          }
        </div>

        <div class="simpli-floating-box-title text-center">
          <span class="color-tertiary">
            Ingresa y haz todo más <span class="simpli-color1"> Simpli </span>
          </span>
        </div>

      </div>

      @if (step === 'email' && !useOtp && !noCompanyAccess) {
        <div>
          <form [formGroup]="loginForm" (submit)="submitForm($event, loginForm.value)" class="form-login animate__animated animate__fadeIn">

            <mat-form-field appearance="fill" color="primary">
              <mat-label>Correo electrónico</mat-label>
              <input formControlName="username" matInput type="email" required>
              <mat-hint>Ingresa tu correo electrónico</mat-hint>
              @if (loginForm.controls['username'].hasError('required')) {
                <mat-error>
                  Este campo es <strong>obligatorio</strong>
                </mat-error>
              }
              @if (loginForm.controls['username'].hasError('email')) {
                <mat-error>
                  Debe ser un correo electrónico valido
                </mat-error>
              }
              @if (loginForm.controls['username'].hasError('invalid')) {
                <mat-error>
                  {{ loginForm.controls['username'].getError('invalid') }}
                </mat-error>
              }
              <mat-icon matSuffix class="simpli-color-gris">email</mat-icon>
            </mat-form-field>

            <mat-form-field appearance="fill" color="primary" style="margin-top: 20px;">
              <mat-label>Contraseña</mat-label>
              <input formControlName="password" matInput [type]="hide ? 'password' : 'text'" required>
              <button matSuffix mat-icon-button type="button" (click)="hide = !hide" [attr.aria-label]="'Ocultar password'"
                [attr.aria-pressed]="hide">
                <mat-icon class="simpli-color-gris">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              <mat-hint>Ingresa tu contraseña</mat-hint>
              @if (loginForm.controls['password'].hasError('required')) {
                <mat-error>
                  Este campo es <strong>obligatorio</strong>
                </mat-error>
              }
              @if (loginForm.controls['password'].hasError('invalid')) {
                <mat-error>
                  {{ loginForm.controls['password'].getError('invalid') }}
                </mat-error>
              }
            </mat-form-field>

            @if(modeProd?.ocultar_en_prod() == false){

              <div class="new-cliente">
                <mat-slide-toggle formControlName="beta_tester">Experimentar nuevo portal</mat-slide-toggle>

              </div>

            }


            <div class="btn-container">
              <button class="primary-button" [disabled]="showSpinner" mat-flat-button type="submit" color="primary" style="margin-right: 0px;">
                @if (showSpinner == false) {
                  <mat-label>Ingresar</mat-label>
                }
                @if (showSpinner == true) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:var(--simpli-secondary);font-size: 18px;">progress_activity</span></span>
                }
              </button>
            </div>

            <div class="center-div">
              <a mat-button class="label-button" routerLink="/forgot-password">¿Olvidaste tu contraseña?</a>
              <div class="color-tertiary">o</div>
              <a mat-button class="label-button" type="button" (click)="switchToOtpLogin()">Ingresar con código</a>
              @if (alianza !== 'ingram') {
                <div class="color-tertiary">o</div>
                <a mat-button class="label-button" [routerLink]="['/registro-empresa']">Regístrate aquí</a>
              }
            </div>

          </form>
        </div>
      }

      @if (step === 'email' && useOtp && !noCompanyAccess) {
        <div>
          <form [formGroup]="valForm" (submit)="requestCode($event, valForm.value)" class="form-login animate__animated animate__fadeIn">

            <mat-form-field appearance="fill" color="primary">
              <mat-label>Correo electrónico</mat-label>
              <input formControlName="username" matInput type="email" required>
              <mat-hint>Ingresa tu correo electrónico</mat-hint>
              @if (valForm.controls['username'].hasError('required')) {
                <mat-error>
                  Este campo es <strong>obligatorio</strong>
                </mat-error>
              }
              @if (valForm.controls['username'].hasError('email')) {
                <mat-error>
                  Debe ser un correo electrónico valido
                </mat-error>
              }
              @if (valForm.controls['username'].hasError('invalid')) {
                <mat-error>
                  {{ valForm.controls['username'].getError('invalid') }}
                </mat-error>
              }
              <mat-icon matSuffix class="simpli-color-gris">email</mat-icon>
            </mat-form-field>

            @if(modeProd?.ocultar_en_prod() == false){

              <div class="new-cliente">
                <mat-slide-toggle formControlName="beta_tester">Experimentar nuevo portal</mat-slide-toggle>

              </div>

            }


            <div class="btn-container">
              <button class="primary-button" [disabled]="showSpinner" mat-flat-button type="submit" color="primary" style="margin-right: 0px;">
                @if (showSpinner == false) {
                  <mat-label>Enviar código</mat-label>
                }
                @if (showSpinner == true) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:var(--simpli-secondary);font-size: 18px;">progress_activity</span></span>
                }
              </button>
            </div>

            <div class="center-div">
              <a mat-button class="label-button" type="button" (click)="switchToPasswordLogin()">Ingresar con mi contraseña</a>
              @if (alianza !== 'ingram') {
                <div class="color-tertiary">o</div>
                <a mat-button class="label-button" [routerLink]="['/registro-empresa']">Regístrate aquí</a>
              }
            </div>

          </form>
        </div>
      }

      @if (noCompanyAccess) {
        <div class="form-login animate__animated animate__fadeIn">
          <p style="text-align:center;">
            Detectamos que tu cuenta está inactiva.<br>
            Solicita asistencia al siguiente número.
          </p>

          <div class="btn-container">
            <button class="primary-button" mat-flat-button type="button" color="primary" style="margin-right: 0px;" (click)="contactar_cx()">
              <mat-label>Solicitar asistencia</mat-label>
            </button>
          </div>

          <div class="center-div">
            <a mat-button class="label-button" type="button" (click)="backToEmail()">Usar otro correo</a>
          </div>
        </div>
      }

      @if (step === 'code' && !noCompanyAccess && !passwordMode) {
        <div>
          <form [formGroup]="codeForm" (submit)="verifyCode($event)" class="form-login animate__animated animate__fadeIn">

            <p style="text-align:center;">Enviamos un código de acceso a<br><strong>{{ valForm.controls['username'].value }}</strong></p>

            <mat-form-field appearance="fill" color="primary">
              <mat-label>Código de acceso</mat-label>
              <input formControlName="code" matInput type="text" inputmode="numeric" maxlength="6" style="letter-spacing: 4px;">
              <mat-hint>Ingresa el código de 6 dígitos que enviamos a tu correo</mat-hint>
              @if (codeForm.controls['code'].hasError('required')) {
                <mat-error>
                  Este campo es <strong>obligatorio</strong>
                </mat-error>
              }
              @if (codeForm.controls['code'].hasError('pattern')) {
                <mat-error>
                  Debe tener 6 dígitos
                </mat-error>
              }
              @if (codeForm.controls['code'].hasError('invalid')) {
                <mat-error>
                  {{ codeForm.controls['code'].getError('invalid') }}
                </mat-error>
              }
            </mat-form-field>

            <div class="btn-container">
              <button class="primary-button" [disabled]="showSpinner" mat-flat-button type="submit" color="primary" style="margin-right: 0px;">
                @if (showSpinner == false) {
                  <mat-label>Ingresar</mat-label>
                }
                @if (showSpinner == true) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:var(--simpli-secondary);font-size: 18px;">progress_activity</span></span>
                }
              </button>
            </div>

            <div class="center-div">
              <a mat-button class="label-button" type="button" [disabled]="resendCooldown > 0 || showSpinner" (click)="resendCode()">
                {{ resendCooldown > 0 ? 'Reenviar código (' + resendCooldown + 's)' : 'Reenviar código' }}
              </a>
              <div class="color-tertiary">o</div>
              <a mat-button class="label-button" type="button" (click)="backToEmail()">Usar otro correo</a>
              <div class="color-tertiary">o</div>
              <a mat-button class="label-button" type="button" (click)="showPasswordLogin()">Ingresar con mi contraseña</a>
            </div>

          </form>
        </div>
      }

      @if (step === 'code' && !noCompanyAccess && passwordMode) {
        <div>
          <form [formGroup]="passwordForm" (submit)="loginWithPassword($event)" class="form-login animate__animated animate__fadeIn">

            <p style="text-align:center;">Ingresa la contraseña de<br><strong>{{ valForm.controls['username'].value }}</strong></p>

            <mat-form-field appearance="fill" color="primary">
              <mat-label>Contraseña</mat-label>
              <input formControlName="password" matInput [type]="hidePassword ? 'password' : 'text'">
              <button type="button" mat-icon-button matSuffix (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                <mat-icon style="color: gray;">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
              </button>
              @if (passwordForm.controls['password'].hasError('required')) {
                <mat-error>
                  Este campo es <strong>obligatorio</strong>
                </mat-error>
              }
              @if (passwordForm.controls['password'].hasError('invalid')) {
                <mat-error>
                  {{ passwordForm.controls['password'].getError('invalid') }}
                </mat-error>
              }
            </mat-form-field>

            <div class="btn-container">
              <button class="primary-button" [disabled]="showSpinner" mat-flat-button type="submit" color="primary" style="margin-right: 0px;">
                @if (showSpinner == false) {
                  <mat-label>Ingresar</mat-label>
                }
                @if (showSpinner == true) {
                  <span><span class="material-symbols-outlined mat-spin" style="color:var(--simpli-secondary);font-size: 18px;">progress_activity</span></span>
                }
              </button>
            </div>

            <div class="center-div">
              <a mat-button class="label-button" type="button" (click)="showCodeLogin()">Ingresar con código</a>
              <div class="color-tertiary">o</div>
              <a mat-button class="label-button" type="button" (click)="backToEmail()">Usar otro correo</a>
            </div>

          </form>
        </div>
      }

    </mat-card-content>
  </mat-card>
</section>
